import { NgFor, NgIf, CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation, forwardRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Params, Router, RouterLink, RouterOutlet } from '@angular/router';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FileManagerComponent } from 'app/modules/admin/apps/file-manager/file-manager.component';
import { FileManagerService } from 'app/modules/admin/apps/file-manager/file-manager.service';
import { ItemPagination, pickerDirectory, OversizedFile, assetsFilterFields, AssetsSearch, SortingPreference } from 'app/modules/admin/apps/file-manager/file-manager.types';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule, Sort } from '@angular/material/sort';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { HttpClientModule } from "@angular/common/http";
import { MatTableModule } from '@angular/material/table';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { FuseFindByKeyPipe } from '@fuse/pipes/find-by-key/find-by-key.pipe';
import { DocumentService } from 'app/services/document.service';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { EventService } from 'app/services/event.service';
import { Asset, AssetPathItem, CreateFolder, FileUploadOptions } from 'app/models/document';
import * as consts from 'app/shared/global-constants';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { FileUploader, FileUploadModule, FileDropDirective } from 'ng2-file-upload';
import { Util } from 'app/models/util';
import { FileUploadQueueService } from 'app/services/file-upload-queue.service';
import { FormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FuseScrollbarDirective } from '@fuse/directives/scrollbar';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { fuseAnimations } from '@fuse/animations';
import { labelColorDefs } from 'app/shared/global-constants';
import { DndDragImageRefDirective, DndDraggableDirective, DndDropzoneDirective, DndHandleDirective} from 'ngx-drag-drop';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { LabelService } from 'app/services/label.service';
import { DataVisualBarComponent } from '../data-visuals/dv-bar/dv-bar.component';
import { MatDividerModule } from '@angular/material/divider';
import { FilterComponent } from '../filter/filter.component';
import { FavouriteService } from 'app/services/favourite.service';
import { UserImpl } from 'app/models/user';
import { FileSizePipe } from '@fuse/pipes/file-size.pipe';
import { LpmLabelPipe } from '@fuse/pipes/lpm-label.pipe';
import { FullNamePipe, getFullName } from '@fuse/pipes/full-name.pipe';
import { LockService } from 'app/services/lock.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { FileManagerDetailsComponent } from '../details/details.component';
import { AuthService } from 'app/services/auth.service';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import animationData from '../../../../../../assets/images/lottie/locked-folder';
import { LpmConfig } from 'app/models/lpm.config';
import { NgxLoadingModule } from 'ngx-loading';
import { SearchComponent } from 'app/layout/common/search/search.component';
import { SearchResultComponent } from '../search-result/search-result.component';
import { ActionDirective } from '@fuse/directives/action.directive';
import { IsDisplayedDirective } from '@fuse/directives/isDisplayed.directive';
import { CopilotChatComponent } from '../../open-web-ui/copilot-chat/copilot-chat.component';
import { Agent, Assistant, CopilotAssetDetails, CopilotSettings } from 'app/models/copilot.model';
import { RagService } from 'app/services/rag.service';
import { DesktopAgentService } from 'app/services/desktop-agent.service';
import { DesktopAgentBannerComponent } from '../desktop-agent/desktop-agent-banner.component';
import { ActionRegistryService } from 'app/shared/action-registry.service';
import { ClickDebouncer } from 'app/shared/click-debouncer';
import { Title } from '@angular/platform-browser';
import { CUSTOM_THEME_ELEMENTS_CLASSES } from 'app/constants';
import {PermissionsService} from '../../file-manager/permissions/permissions.service';

@Component({
    selector: 'file-manager-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss',
    ],
    schemas:[CUSTOM_ELEMENTS_SCHEMA],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatSidenavModule,
        RouterOutlet,
        NgIf,
        RouterLink,
        NgFor,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatOptionModule,
        MatRippleModule,
        MatFormFieldModule,
        MatInputModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSortModule,
        HttpClientModule,
        MatTableModule,
        FuseFindByKeyPipe,
        MatMenuModule,
        CommonModule,
        MatExpansionModule,
        FileUploadModule,
        MatMenuModule,
        CommonModule,
        MatExpansionModule,
        MatPaginatorModule,
        ScrollingModule,
        FuseScrollbarDirective,
        DndDraggableDirective,
        DndHandleDirective,
        DndDragImageRefDirective,
        DndDropzoneDirective,
        ToastrModule,
        DataVisualBarComponent,
        MatDividerModule,
        FormsModule,
        FilterComponent,
        FileSizePipe,
        OverlayModule,
        FileManagerDetailsComponent,
        LottieComponent,
        NgxLoadingModule,
        MatTooltipModule,
        SearchComponent,
        SearchResultComponent,
        CopilotChatComponent,
        ActionDirective,
        DesktopAgentBannerComponent,
        forwardRef(() => IsDisplayedDirective),
        forwardRef(() => LpmLabelPipe),
        FullNamePipe
    ],
     animations: [
        fuseAnimations,
        trigger('overlayAnimation', [
            transition(':enter', [
                style({ opacity: 0, transform: 'scale(0.5)' }),
                animate('300ms ease-out', style({ opacity: 1, transform: 'scale(1)' })),
            ]),
            transition(':leave', [
                animate('300ms ease-in', style({ opacity: 0, transform: 'scale(0.5)' })),
            ]),
        ]),
        trigger('slideDown', [
          state('void', style({
            height: '0',
            opacity: '0',
            overflow: 'hidden',
          })),
          state('*', style({
            height: '*',
            opacity: '1',
          })),
          transition(':leave', [
            animate('0.3s ease-out')
          ]),
        ]),
      ],

})
export class FileManagerListComponent implements OnInit, OnDestroy {
    @Input() defaultView: string = null;
    @Input() lpm: LpmConfig = new LpmConfig();
    @ViewChild('matDrawer', { static: true }) matDrawer: MatDrawer;
    @ViewChild('viewport', { static: false }) viewport: CdkVirtualScrollViewport;

    drawerMode: 'side' | 'over';
    assets: Asset[] = [];
    folders = [];
    files = [];

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    labelColors: any;
    labels = [];
    viewMode = 'GRID';
    user : UserImpl = null;

    page: ItemPagination = new ItemPagination();
    isLoading: boolean = true;

    radius: number;
    color: string;
    isStatsPanelOpen = false;
    // we create an object that contains coordinates
    menuTopLeftPosition = { x: 0, y: 0 };

    // reference to the MatMenuTrigger in the DOM
    @ViewChild('fmItemActionMenuItemTrigger', { static: true }) matMenuTrigger: MatMenuTrigger;
    @ViewChild('fmActionMenuMainTrigger', { static: true }) matMenuMainTrigger: MatMenuTrigger;
    @ViewChild('filterPanel', { static: true }) filterPanel: MatExpansionPanel;
    @ViewChild('multiItemSelectPanel', { static: true }) multiItemSelectPanel: MatExpansionPanel;
    @ViewChild('statsPanel', { static: true }) statsPanel: MatExpansionPanel;

    selectedRows: Asset[] = [];
    routeFolderId = null;

    public paths:AssetPathItem[] = [];
    displayedPaths: AssetPathItem[] = [];
    showFullPaths: boolean = false;
    pageLimitList = consts.pagelimits;
    total = 0;
    showScrollToTopButton = false;
    private scrollSubscription: Subscription;

    totalAssets:{files:number;folders:number}={files:0,folders:0}

    assetsFilterFields:assetsFilterFields = new assetsFilterFields()

    teamDecorator = {};
    itemDecoratorComplete: boolean = false;
    assetsSearch:AssetsSearch=new AssetsSearch()
    subs = new Subscription();
    assetId = null;
    activeTab  = null;
    public trigger: HTMLElement | undefined;
    isAuthorized:boolean=true
    public lottieConfig: AnimationOptions;
    isAllRowsSelected:boolean = false;
    rootFolderId:string = null;
    showSearchResults:boolean = false;
    inputSearch:AssetsSearch = null;
    isWebComponent:boolean = false;
    copilotAssetId: string = null; // Asset ID for Copilot mode
    chatUserDetail: {name:string,email:string} = {name:'User',email:""}; // Default chat theme
    settings: CopilotSettings = new CopilotSettings();
    isCopilotEnabled: boolean = false;
    isLeastOneAgentEnabled: boolean = false;
    isLeastOneFolderAgentEnabled: boolean = false;
    selectedAssistant:Assistant= new Assistant();
    selectedAgent: Agent = new Agent();
    currentFolderDetails: CopilotAssetDetails = new CopilotAssetDetails();
    isLeastOneAssistantOrAgentEnabled:boolean=false;

    private readonly _clicks = new ClickDebouncer();
    // Ignore clicks right after navigating
    private _navigatedAt = 0;
    private readonly _navClickGuardMs = 500;

    // ── File upload ──────────────────────────────────────────────────────
    @ViewChild('dropZoneInner', { static: true }) dropZoneInner: ElementRef;
    @ViewChild('ng2FileDrop', { static: true }) ng2FileDrop: FileDropDirective;
    @ViewChild('uploaderInputHidden') uploaderInputHidden: ElementRef;
    @ViewChild('folderInput') folderInput!: ElementRef<HTMLInputElement>;
    isDragActive = false;
    hasBaseDropZoneOver = false;
    fileUploader: FileUploader;
    oversizedFiles:OversizedFile[] = [];

    // -----------------------------------------------------------------------------------------------------

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        public _fileManagerComponent: FileManagerComponent,
        private _fileManagerService: FileManagerService,
        public docService: DocumentService,
        private favService : FavouriteService,
        public eventSer: EventService,
        public util: Util,
        private _formBuilder: UntypedFormBuilder,
        private _fuseConfirmationService: FuseConfirmationService,
         private _fuseMediaWatcherService: FuseMediaWatcherService,
         public ToastrService:ToastrService,
         private _matDialog: MatDialog,
         private labelService :LabelService,
         private toastr : ToastrService,
         private lockService: LockService,
         private titleService: Title,
         private authService: AuthService,
         private uploadQueueService: FileUploadQueueService,
         private ragService: RagService,
         private _permissionsService:PermissionsService,
         public desktopAgentService: DesktopAgentService,
         private _actionRegistry: ActionRegistryService,
    ) {
      
        this.page.orderOn = 'type';
        this.isWebComponent = this.util.getIsWebApp();
        if(!this.isWebComponent) this.titleService.setTitle("DMS - Home");
         this.lottieConfig = {
            animationData: animationData,
            path: "/assets/images/lottie/locked-folder.json",
            renderer: "svg",
            autoplay: true,
            loop: false,
        };
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

        this.rootFolderId = this.util.getRootFromSession();
        const rootId = this.rootFolderId;

        // Set Asset Type Sorting
        const sort=this.util.getSortingPreference('Home')
        
        this.assetsSearch.sortColumn = sort?.sort?.active as any ?? 'FOLDER_CREATED_DATE';
        this.assetsSearch.sortDirection = this.util.getSortDirection(sort?.sort?.direction) ?? 'DESCENDING';
        this.assetsSearch.parent = rootId;

        this.page.size = Number(this.util.getPageLimit());
        this.routeFolderId = this._activatedRoute.snapshot.params?.folderId ?? rootId ;
        const fileUploadOptions:FileUploadOptions = this.util.getFileUploadOptions(this.rootFolderId,this.lpm);
        this.fileUploader = this.uploadQueueService.initUploader(fileUploadOptions);

        // // Get the label colors
        this.labelColors = labelColorDefs;
        this.getLabels();

        //Load custom icons into material icon registry; ex. <mat-icon toggleLabeltoggleLabelsvgIcon]="'png'"></mat-icon>
        this._fileManagerService.registerIcons();

        // TODO - set viewMode default based on user preference
        this.user = this.util.getUserFromSession() ?? new UserImpl();
        this.chatUserDetail.name = getFullName(this.user);
        this.chatUserDetail.email = this.user?.email;
        this.viewMode = this.defaultView? 'GRID':this.user?.details?.assetView;
        // Subscriptions

        // subscribe to assets event emmiter
        this.subs.add(
            this.eventSer.getData.subscribe((data) => {
                this.getAssets()
              })
          );

        this.subs.add(
            this.eventSer.resetRowsSelection.subscribe((data) => {
                this.cancelBulkAction()
              })
        );

        this.subs.add(
            this.eventSer.onSearchClear.subscribe((data) => {
                this.showSearchResults = false;
              })
        );

        this.subs.add(
            this.eventSer.onRouteChange.subscribe((routeId) => {
               this.folderView(routeId);
              })
        );
        
         // subscribe for route params(folder) change
         this._activatedRoute.params.subscribe((params: Params) => {
            // Handle parameter changes here
            this.routeFolderId = params['folderId']??this.util.getRootFromSession();
            this.assetsSearch.parent=this.routeFolderId;
            const fileUploadOptions:FileUploadOptions = this.util.getFileUploadOptions(this.routeFolderId,this.lpm);
            this.fileUploader = this.util.fileUpload(fileUploadOptions);
            this.fileUploader = this.uploadQueueService.initUploader(fileUploadOptions);
            this.getAssets(true);
        });

         // Subscribe to media query change
         this._fuseMediaWatcherService.onMediaQueryChange$('(min-width: 1200px)')
         .pipe(takeUntil(this._unsubscribeAll))
         .subscribe((state) =>
         {
             // Calculate the drawer mode
             this.drawerMode = state.matches ? 'side' : 'over';

             // Mark for check
             this._changeDetectorRef.markForCheck();
         });

         this.configAfterFileUpload();

        // Load Copilot Assistants
        this.loadSettings();
       
    }

    folderView(folderId){
        this._clicks.cancel();
        this._navigatedAt = Date.now();
        if(this.isWebComponent){
        this.assetsSearch.parent=folderId
        this.routeFolderId = folderId;
        const fileUploadOptions:FileUploadOptions = this.util.getFileUploadOptions(folderId,this.lpm);
        this.page.page = 0;
        this.fileUploader =  this.uploadQueueService.initUploader(fileUploadOptions);
        this.getAssets(true)

        } else {
            this._router.navigateByUrl('apps/file-manager/folders/'+folderId);
        }

    }

    ngAfterViewInit(): void {
        if  (this.assets.length>0)
            setTimeout(() => this.subscribeToScrollEvent(), 4000); 
    }

    getLabels() {
        this.labelService.getLabels().then((res) => {
            this.labels = this.labelService.getData(res);
        }).catch((error) => {
            console.log(error);
        })
    }
    
    async getAssets(loadDirpath:boolean = false) {
        this.isLoading = true;
        this.assets = [];
        this.files = [];
        this.folders = [];
        this.resetSelectedRows();
        this.docService.getAssets(this.page,this.assetsSearch).then((res) => {
            
            this.assets  = this.docService.getData(res);
            const meta = this.docService.getMeta(res)
            
            this.total = meta.total
            this.totalAssets.files = meta.totalFiles
            this.totalAssets.folders = meta.totalFolders

            if (this.assets && this.assets.length > 0) {
                this.folders = this.assets.filter((item) => item.type === 'FOLDER');
                this.files = this.assets.filter((item) => item.type === 'FILE');
            }
            this.getAndSetCurrentFolderCopilotDetails();
            if(loadDirpath){
                this.getPath()
            }
            this.renderTeamMembers();
            this.isLoading = false;
            this.isAuthorized = true;

        }).catch((err) => {
            this.isLoading = false;
            if(err.code === "1900"){
                this.isAuthorized = false;
            }
        })
        this._changeDetectorRef.markForCheck();
    }

    async getPath() {
        this.isLoading = true;
        this.docService.getAssetsPath(this.assetsSearch.parent).then((res) => {
            const response = this.docService.getData(res)
            this.paths = response
            this.updateDisplayedPaths();
            this.isLoading = false;

        }).catch((err) => {
            this.isLoading = false;
        })
        this._changeDetectorRef.markForCheck();
    }

    /**
     * Handles the page change event.
     * @param e The page event containing the new page information.
     */
    onPageChanged(e: PageEvent) {
        this.page.length = e.length;
        this.page.size = e.pageSize;
        this.page.page = e.pageIndex;
        this.util.setPageLimit(this.page.size);
        this.getAssets();
    }

    /**
     * Sorts the data based on the provided sort object.
     * 
     * @param sort - The sort object containing the active sorting property.
     */
    sortData(sort : Sort){
        this.page.orderOn = sort.active;
        this.assetsSearch.sortDirection=this.util.getSortDirection(sort.direction)
        const sortPrefernce:SortingPreference={viewName:'Home',sort}
        this.util.setSortingPreference(sortPrefernce)
        this.assetsSearch.sortColumn=sort.active as any
        this.getAssets();
     }

    /**
     * Lifecycle hook that is called when the component is destroyed.
     * It is used to perform cleanup tasks such as unsubscribing from subscriptions.
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this.subs.unsubscribe();
          
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        if (this.scrollSubscription) {
            this.scrollSubscription.unsubscribe();
        }
    }

    /**
     * Subscribes to the scroll event of the viewport element.
     * @returns {void}
     */
    subscribeToScrollEvent() {
        this.scrollSubscription = this.viewport.elementScrolled().subscribe(event => {
            this.handleScrollEvent(event);
        });
    }
    
    handleScrollEvent(event) {
        this.showScrollToTopButton = this.viewport.getOffsetToRenderedContentStart() > 30;
    }

    scrollToTop() {
        // Use the viewport's API to scroll to the top
        //this.viewport.scrollToOffset(0);
        //this.viewport.scrollToIndex(0);
        this.viewport.scrollTo({ top: 0, behavior: 'smooth' });
        this.showScrollToTopButton = false;
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On backdrop clicked
     */
    onBackdropClicked(): void {
        // Go back to the list
        this._router.navigate(['./'], { relativeTo: this._activatedRoute });

        // Mark for check
        this._changeDetectorRef.markForCheck();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    /**
     * Toggle the viewMode between 'grid' and 'cards'
     *
     * @param viewMode
     */
    toggleViewMode(mode): void {
        this.multiItemSelectPanel.close();
        this.viewMode =  mode == 'LIST' ? 'GRID' : 'LIST';
        if(!this.defaultView){
            this.user.details.assetView = this.viewMode;
            this.util.setUserInSession(this.user);
        }
    }

    /** 
     * Method called when the user click with the right button 
     * @param event MouseEvent, it contains the coordinates 
     * @param item Our data contained in the row of the table 
     */
    async onRightClick(event: MouseEvent, selectedItem: Asset): Promise<void> {
        // preventDefault avoids to show the visualization of the right-click menu of the browser 
        event.preventDefault();
        // we record the mouse position in our object 
        this.menuTopLeftPosition.x = event.clientX;
        this.menuTopLeftPosition.y = event.clientY;

        // we open the menu 
        // we pass to the menu the information about our object 
        this.matMenuTrigger.menuData = { item: selectedItem };

        // we open the menu 
        this.matMenuTrigger.openMenu();
        
        // check parsing status
        await this.checkCopilotParsingStatus(selectedItem); 
     
    }
  
    /**
     * Handles the right-click event on the main element.
     * 
     * @param event - The mouse event triggered by the right-click action.
     * 
     * This method prevents the default context menu from appearing,
     * records the mouse position, and opens a custom context menu.
     */
    onRightClickMain(event: MouseEvent): void {
        event.preventDefault();
        // we record the mouse position in our object 
        this.menuTopLeftPosition.x = event.clientX;
        this.menuTopLeftPosition.y = event.clientY;

        // we open the menu 
        this.matMenuMainTrigger.openMenu();
    }
  
    /**
     * Toggle star
     */
    toggleStar(item: Asset): void {
        //this.isLoading = true;
        item.favourite = item.favourite ? !item.favourite : true;
        this.favService.favorite(item.id, item.favourite).then((res) => {
            if (!item.favourite) {
                this.toastr.warning("Removed from favorite")
                this.eventSer.checkUnreadMessages.emit("favourite");
            } else {
                this.toastr.info("Added to favorite")
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    /**
     * Toggle star
     */
    toggleStar_multi(): void {
        // Update the asset
        if (this.selectedRows.length > 0) {
            const isAllFavSelected=this.selectedRows.every(row=>row.favourite==true)
            const ids=this.selectedRows.map(row => {
                return row.id
            })
            this.favService.favorite(ids,!isAllFavSelected).then(res => {
                this.getAssets()
            }).catch(error=>{
                console.log(error)
            })
        }
    }

    /**
    * Toggle label
    *
    * @param label
    */
    toggleLabel(assetId, labelId, event : MatCheckbox): void {
        if (!event.checked) {
            this.labelService.assignLabel(labelId, assetId).then((res) => {
                this.toastr.info("Label applied");
                this.eventSer.checkUnreadMessages.emit("Label applied");
                this.getAssets();
            }).catch((error) => {
                console.log(error);
            })
         } else 
            this.deleteLabel(labelId, assetId);
    }

    /**
     * Toggles the filter panel open and close.
     * Clears the filters on close.
     * Closes the multiItemSelectPanel if opening the filterPanel.
     * Clears the selectedRows if filter panel is open and then user makes a parameter selection.
     */
    toggleFilterPanel(): void {
        // toggle the filterPanel open and close
        this.filterPanel.toggle();
        // TODO - clear the filters on close

        //if opening the filterPanel, clear & close the multiItemSelectPanel
        if (this.filterPanel.opened) {
           this.cancelBulkAction()
        }
    }

    /**
     * Toggles the stats panel open and close.
     * Clears the filters on close.
     */
    toggleStatsPanel(): void {
        // toggle the panel open and close
        this.statsPanel.toggle();
        // TODO - clear the filters on close 
    }

    /**
     * Checks if a file is selected.
     * @param file - The file to check.
     * @returns True if the file is selected, false otherwise.
     */
    isSelected(file: any): boolean {
        return this.selectedRows.some(selectedFile => selectedFile.id === file.id);
    }

    /**
     * Cancels the bulk action by clearing the selected rows and closing the multi-item select panel.
     */
    cancelBulkAction(): void {
        this.selectedRows = [];
        this.multiItemSelectPanel.close();
        this.isAllRowsSelected = false;
    }

    /**
     * Downloads the specified asset.
     * 
     * @param asset - The asset to download.
     */
    download(asset : Asset): void {
        this._fileManagerService.openDialog_download(asset);
    }

    /**
     * Downloads multiple files as a zip.
     * Files will be identified in the backend by the selectedRows array.
     * For each file, checks if the user has permission to download.
     * If the user does not have permission, rejects all and returns an error message.
     * If the user has permission, downloads the files as a zip.
     */
    download_multi(): void {
        //TODO - download multiple files as a zip. Files will be identified in the backend by the selectedRows array. 
        //For each file, check if user has permission to download. If no permission, reject all and return error message.
        //If user has permission, download as zip.
        let assetIds: string[] = []
        if (this.selectedRows.length>1) {
            assetIds = this.selectedRows.map((x) => x.id);
            this._fileManagerService.openDialog_download_multi(assetIds)
        }
        else {
            const asset = this.selectedRows[0]
            this._fileManagerService.openDialog_download(asset);
        }
    }

    /**
     * Moves the specified file to the trash.
     * 
     * @param file - The file to be moved to the trash.
     * @param type - The type of file being moved to the trash.
     */
    trash(file:Asset): void {
        const ids:string[]=[file.id]
        this._fileManagerService.openDialog_trash(ids, file.type.toLowerCase());
    }

    /**
     * Trashes the selected assets.
     * If only one asset is selected, it trashes that asset.
     * If multiple assets are selected, it presents a confirmation prompt and then trashes all selected assets.
     */
    trash_multi(asset): void {
        let assetIds: string[] = []
        assetIds = this.selectedRows.map((x) => x.id);
        const isAnyNotDeletable = this.selectedRows.some(file => !file.deletable);
        if(isAnyNotDeletable){
            this.toastr.error("One or more selected items cannot be deleted.")
            return;
        }
        if (this.selectedRows.length) this._fileManagerService.openDialog_trash_multi(assetIds);
        else  this.trash(asset);
    }

    /**
     * Stops the propagation of the specified mouse event.
     * 
     * @param event - The mouse event to stop propagation for.
     */
    stopPropagation(event: MouseEvent): void {
        this._fileManagerService.stopPropagation(event);
    }

    @HostListener('dragover', ['$event'])
    /**
     * Handles the drag over event.
     * @param event The drag over event.
     */
    onDragOver(event: Event) {
        const parentElement = (event.target as HTMLElement).parentElement;
        if (parentElement && parentElement.classList.contains('specific-class')) {
            // Your logic here, e.g., trigger something or set a variable
        }
    }


    /**
     * Returns the color associated with the given file type.
     * 
     * @param filetype - The file type.
     * @returns The color associated with the file type.
     */
    getTypeColor(filetype: string): string {
        return this.util.getTypeColor(filetype);
    } 
 
     /**
     * onDragStart:
     * catch the drag start event; configure the UI representation of the draggable item
     */
    onDragStart(event, asset: Asset){
        this.util.onDragStart(event, asset);
    }

    /**
     * onDrop:
     * triggers the confirmation prompt; on user confirm, file/files/folder move into another folder location
     */
    onDrop(event,destination){
        const single_source:Asset=event.data
        const multi_ids:string[]=this.selectedRows.map(asset=>asset.id)
        const is_multi_move:boolean=multi_ids.length>0?true:false
        const sourceIds:string[]=is_multi_move?multi_ids:[single_source.id]
        const source_title=is_multi_move?(multi_ids.length+" files"):single_source.name

        let message=`You are about to move <b>"${source_title}"</b> to "${destination.name}". <br><br> <span class="font-medium">Are you sure?</span>`

        const access_warning=`</br> </br><span style="color:'red'"> Note: </span><span>This folder will be visible to everyone who can see <b> "${destination.name}"</b> </span>`

        message = single_source.type == 'FOLDER' ? message + access_warning : message;
        const defaultConfig = this.util.moveForm;
        const fullConfig = {...defaultConfig, message:message};
        const builder = this._formBuilder.group(fullConfig).value

        const dialogRef = this._fuseConfirmationService.open(builder);
        
        // Subscribe to afterClosed from the dialog reference
        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'confirmed') {
                this.docService.moveAsset(sourceIds, destination.id).then(res=>{
                   this.getAssets()
                }).catch(error=>{
                    console.log(error)
                });
                
            }
        });
    }
 
    /**
     * Handles the event when a file is selected.
     * @param event - The event object containing the selected files.
     */
    onFileSelected(event) {
        let files:File[] = event.target.files;
        const { files:allowedFiles, oversizedFiles:newOversizedFiles } = this.util.filterOversizedFiles(files);
        files = allowedFiles;
        this.oversizedFiles.push(...newOversizedFiles);

        const startUpload = () => {
            this.configFileUpload();
            this.uploadQueueService.uploader.addToQueue(files);
            this.uploaderInputHidden.nativeElement.value = '';
            this.uploadQueueService.show();
            this.uploadQueueService.uploader.uploadAll();
        };

        if (this.oversizedFiles.length) {
            this.confirmOversizedFiles().then(confirmed => {
                if (confirmed && files.length > 0) {
                    startUpload();
                }
            });
            return;
        }

        startUpload();
    }

    configFileUpload(parentId?: string) {
        const folderId = parentId ?? this.routeFolderId;
        const fileUploadOptions: FileUploadOptions = this.util.getFileUploadOptions(folderId, this.lpm);
        this.fileUploader = this.uploadQueueService.initUploader(fileUploadOptions);
        this.uploadQueueService.copilotConfig = this.lpm?.copilotConfig ?? null;
    }

    /**
     * Configures the file uploader after a file upload.
     */
    configAfterFileUpload(){
        // Delegate upload event handling to the singleton service
        this.uploadQueueService.onCompleteItem$.pipe(takeUntil(this._unsubscribeAll)).subscribe(({item, response}) => {
            try {
                const newAsset: Asset = JSON.parse(response)?.data;
                if (item.some.duplicate_action === 'overwritten') {
                    this.replaceUploadedFile(newAsset);
                } else {
                    this.appendUploadedFile(newAsset);
                }
            } catch (error: any) {
                if (this.util.InvalidErrorResponse(error.message)) {
                    throw('Invalid Error Response');
                }
            }
        });

        this.uploadQueueService.onCompleteAll$.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.uploadQueueService.pendingExistFiles.length) {
                this.getAssets();
            }
        });

    }


    // Handle Drop File Zone

     /**
     * TODO - hasBaseDropZoneOver value is registered multiple times in browser, this seems to be a known issue with the directive when there are children elements. 
     * Therefore we need to optimize. Options include grabbing the event from the directive and using it in the component, 
     * or using a service to communicate between the directive and the component.  
     * Perhaps setting 'dragover' and 'dragleave' events on the directive.
     * https://github.com/valor-software/ng2-file-upload/issues/502
     * https://github.com/progtarek/angular-drag-n-drop-directive/blob/master/src/app/direcitves/dnd.directive.ts
     *
     * @param e 
     */
     fileOverBase(e: any): void {
      // Only set hasBaseDropZoneOver if isDragActive is false
        if (!this.isDragActive) {
            this.hasBaseDropZoneOver = e;
            this.isDragActive = true; // Set isDragActive to true on the first dragover event
        }
    }

    async onNativeDrop(event: DragEvent): Promise<void> {
        this.isDragActive = false;
        const items = event.dataTransfer?.items;
        if (!items) return;

        const targetFolderId = this.routeFolderId;

        const folderEntries: FileSystemDirectoryEntry[] = [];
        const fileEntries: FileSystemFileEntry[] = [];
        for (const item of Array.from(items)) {
            const entry = item.webkitGetAsEntry?.();
            if (entry?.isDirectory) {
                folderEntries.push(entry as FileSystemDirectoryEntry);
            } else if (entry?.isFile) {
                fileEntries.push(entry as FileSystemFileEntry);
            }
        }
        if (folderEntries.length === 0 && fileEntries.length === 0) return;

        this.uploadQueueService.startPreparing();

        const droppedFiles = await Promise.all(fileEntries.map(entry => this.util.getFileFromDroppedEntry(entry)));
        const validFiles: File[] = [];
        for (const file of droppedFiles) {
            if (file.size < consts.DMS_MAX_FILE_SIZE_BYTES) {
                validFiles.push(file);
            } else {
                this.oversizedFiles.push({ name: file.name, size: this.util.formatBytes(file.size, 1), path: file.name });
            }
        }

        // Phase 1: traverse all folders, accumulate oversized files with full path context
        const uploads: { folder: { name: string }, hierarchy: any[], isParentIncluded: boolean }[] = [];
        for (const folderEntry of folderEntries) {
            const result = await this.util.traverseDroppedDirectory(folderEntry);
            this.oversizedFiles.push(
                ...result.oversizedFiles.map(f => ({ ...f, path: `${folderEntry.name}/${f.path}` }))
            );
            const folder = { name: folderEntry.name };
            const isParentIncluded = await this.util.shouldIncludeParentFolderInUpload(folderEntry.name, this.lpm);
            uploads.push({ folder, hierarchy: result.hierarchy, isParentIncluded });
        }

        const runUploads = async () => {
            for (const { folder, hierarchy, isParentIncluded } of uploads) {
                await this.uploadFolder(folder, hierarchy, isParentIncluded);
            }
            for (const file of validFiles) {
                await this.uploadFile(file, targetFolderId);
            }
            this.getAssets(); // refresh once for the whole batch, not once per folder/file
        };

        // Phase 2: one dialog for all oversized files, then upload everything valid
        if (this.oversizedFiles.length) {
            const confirmed = await this.confirmOversizedFiles();
            if (!confirmed) {
                this.uploadQueueService.stopPreparing();
                return;
            }
        }

        await runUploads();
        this.uploadQueueService.stopPreparing();
    }

    onDragLeave(e: any): void {
        this.isDragActive = false; // Reset isDragActive on drag leave
    }

    /**
     * Opens the native file manager and prompts the user to select a directory.
     * After selection, traverses the directory to generate the folder structure.
     * Prompts the support User to choose whether to include the selected folder itself or only its contents in the upload.
     * Then checks for oversized files and proceeds with the upload accordingly.
     */
    async openFileManager() {
        // Chrome / Edge, i.e Supported browsers
        if ('showDirectoryPicker' in window) {
            try {
                const folder = await (window as any).showDirectoryPicker();
                const hierarchyAndMaxSizeFiles = await this.util.traverseDirectory(folder);
                const hierarchy = hierarchyAndMaxSizeFiles.hierarchy;
                this.oversizedFiles = [...this.oversizedFiles,...hierarchyAndMaxSizeFiles.oversizedFiles];
                const isParentIncluded:boolean = await this.util.shouldIncludeParentFolderInUpload(folder.name,this.lpm);
                await this.validateAndUploadFolder (folder, hierarchy, isParentIncluded);
            } catch (e) {
                // User cancelled picker
                return;
            }
        }

        // Unsupported browsers
        else {
            this.folderInput.nativeElement.value = '';
            this.folderInput.nativeElement.click();
        }
    }

    async onFolderInputChange(event: Event) {

        // Subscribe to afterClosed from the dialog reference
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) {
            return;
        }

        const hierarchyAndMaxSizeFiles = this.util.buildHierarchyFromFiles(input.files);
        const hierarchy = hierarchyAndMaxSizeFiles.hierarchy;
        this.oversizedFiles = [...this.oversizedFiles, ...hierarchyAndMaxSizeFiles.oversizedFiles];
        // Infer root folder name from first file
        const firstPath = input.files[0].webkitRelativePath;
        const folderName = firstPath.split('/')[0];

        const folder = { name: folderName };

        const isParentIncluded = await this.util.shouldIncludeParentFolderInUpload(folderName, this.lpm);
        await this.validateAndUploadFolder(folder, hierarchy, isParentIncluded);

    }

    /**
     * Confirms oversized files (if any) before uploading a folder tree.
     * @param folder - Selected folder handle.
     * @param hierarchy - Folder hierarchy to upload.
     * @param isParentIncluded - Include the selected folder itself (default true).
     */
    async validateAndUploadFolder (folder: { name: string }, hierarchy: pickerDirectory[], isParentIncluded:boolean = true): Promise<void> {
        if (this.oversizedFiles.length) {
            const confirmed = await this.confirmOversizedFiles();
            if (!confirmed) return;
        }
        await this.uploadFolder(folder, hierarchy, isParentIncluded);
        this.getAssets(); // refresh once; folder creation bypasses the upload-queue's onCompleteAll refresh
    }

    /**
     * Shows the oversized-files dialog. Resolves true if the user proceeds,
     * false if cancelled; clears oversizedFiles either way.
     */
    private confirmOversizedFiles(): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            const fileList = this.oversizedFiles.map((file, index) =>
                `<div title="${file.path}" class="flex justify-between"><div class="flex-grow flex basis-0"><b>${index + 1}:</b> <span class="line-clamp-1">${file.name}</span></div><b> (${file.size})</b></div>`
            ).join('');
            const message = `${this.oversizedFiles.length} file(s) exceed(s) the maximum allowed size (${this.util.formatBytes(consts.DMS_MAX_FILE_SIZE_BYTES)}) and cannot be uploaded:<br/><br/>${fileList}<br/>Do you want to continue?`;
            const dialogRef = this._fuseConfirmationService.open({
                message,
                title: 'Size Exceeded',
                icon: { color: 'info', name: 'feather:database', show: true },
                actions: {
                    confirm: { label: 'Proceed' },
                    cancel: { show: true, label: 'Cancel upload' },
                },
            });
            dialogRef.afterClosed().subscribe((result) => {
                this.oversizedFiles = [];
                resolve(result === 'confirmed');
            });
        });
    }

    /**
     * Entry point for one dropped/picked folder; delegates to uploadFolderTree.
     * @param folder - The dropped/picked folder (uses folder.name).
     * @param hierarchy - Parsed folder/file tree to recreate on the server.
     * @param isParentIncluded - Whether to wrap contents in a new folder for `folder` itself.
     */
    async uploadFolder(folder: { name: string }, hierarchy: pickerDirectory[], isParentIncluded: boolean) {
        let lastCreatedFolderId = this.routeFolderId;

        if (isParentIncluded) {
            const res: any = await this.createFolder(folder.name, this.routeFolderId);
            lastCreatedFolderId = res.data.id;
        }

        // Recursively recreate the folder/file tree under the resolved parent id
        await this.uploadFolderTree(
            hierarchy,
            lastCreatedFolderId
        );
        this.configFileUpload(); // reset uploader target
    }

    /**
     * Recursively recreates a folder/file tree on the server.
     * @param hierarchy - Folder/file tree to recreate.
     * @param parentId - Server folder ID to create/upload this level into.
     * @param currentPath - Path built up so far, for reporting oversized nested files.
     */
    async uploadFolderTree(hierarchy: pickerDirectory[], parentId: string = null, currentPath: string = '') {
        for (const item of hierarchy) {
            const itemPath = currentPath ? `${currentPath}/${item.name}` : item.name;
            if (item.type === 'directory') {
                // Create the folder and obtain its ID
                const res: any = await this.createFolder(item.name, parentId);
                // Recursively upload the contents of the folder
                const folderId = res.data.id;
                await this.uploadFolderTree(item.children, folderId, itemPath);
            } else if (item.type === 'file') {
                // Upload the file to the parent folder
                if (item.file.size < consts.DMS_MAX_FILE_SIZE_BYTES) {
                    await this.uploadFile(item.file, parentId);
                }
                else
                {
                    const MB = this.util.formatBytes(item.file.size, 1);
                    const oversizedFile = { name: item.file.name, size: MB, path: itemPath };
                    this.oversizedFiles.push(oversizedFile);
                }
            }
        }
    }

    /**
     * Creates a new folder on the server. Used for both the picked/dropped
     * folder's own wrapper and each subfolder while recreating a tree.
     * @param name - Folder name to create.
     * @param parentFolderID - Parent folder ID.
     * @returns Server response for the created folder.
     */
    createFolder(name: string, parentFolderID: string): Promise<any> {
        const folder = new CreateFolder();
        folder.name = name;
        return this.docService.createAsset(folder, parentFolderID).catch(error => {
            console.log(error);
            throw error;
        });
    }

    /**
     * Uploads a file to the server.
     *
     * @param file - The file to be uploaded.
     * @param parentId - The ID of the parent element.
     */
    uploadFile(file: File, parentId: string) {
        this.configFileUpload(parentId);
        this.uploadQueueService.show();
        this.uploadQueueService.uploader.addToQueue([file]);
        this.uploadQueueService.uploader.uploadAll();
    }

    /**
     * Handles the change event of the filter.
     * Updates the assets search criteria and retrieves the assets.
     * 
     * @param event - The event object containing the filter data.
     */
     onFilterChange(event){
        this.assetsSearch = { ...event, parent:this.assetsSearch.parent };
        this.assetsSearch.sortColumn = 'FOLDER_CREATED_DATE';
        this.assetsSearch.sortDirection = 'DESCENDING';

        this.getAssets();
     }

    /**
     * Renders team member creator for each asset.
     */
     renderTeamMembers() {
        this.assets.forEach((asset:Asset) => {
			asset["innerDiv"] = "";

			if (asset.createdBy.profilePic) {
				asset["innerDiv"] +=`<img
                class="shrink-0 w-10 h-10 mr-4 rounded-full overflow-hidden object-cover object-center"
                src="${asset.createdBy.profilePic}"
                [alt]="'Activity image'">`;
			} else {
				let name = getFullName(asset.createdBy).toUpperCase();
                const dec_class = this.util.getUserColor(name);
                const [first, last] = name.split(" ");
				this.teamDecorator[name] = (first?.substring(0, 1) || '') + (last?.substring(0, 1) || '');
				asset["innerDiv"] += ` <div class=" ${dec_class} flex shrink-0 items-center justify-center w-10 h-10 mr-4 rounded-full font-10">
               ${this.teamDecorator[name]}
            </div>`;
			}
        });
        this.itemDecoratorComplete = true;
	}

    /**
     * Checks if the given ID exists in the provided list.
     * @param id - The ID to check.
     * @param list - The list to search in.
     * @returns `true` if the ID exists in the list, `false` otherwise.
     */
    selectedLabel(id,list:any[]) {
        return this.util.selectedLabel(id, list);
    }

    /**
     * Deletes a label for a specific asset.
     * 
     * @param {number} labelId - The ID of the label to be removed.
     * @param {number} assetId - The ID of the asset associated with the label.
     * @returns {Promise<void>} A promise that resolves when the label is successfully removed.
     */
    deleteLabel(labelId,assetId){
        this.labelService.removeLabel(labelId, assetId).then((res)=>{
            this.toastr.warning("Label removed");
            this.eventSer.checkUnreadMessages.emit("Label removed");
            this.getAssets();
        }).catch((error)=>{
          console.log(error);
        })
    }

    /**
     * Copies an asset.
     * 
     * @param asset - The asset to be copied.
     */
    copyAsset(asset){
        let assetIds:string[]=[]
        if(this.selectedRows.length){
            assetIds=this.selectedRows.map(row=>{
                return row.id
            })
        }
        else
        {
            assetIds=[asset.id]
        }
        this.docService.copyAsset(assetIds, this.routeFolderId).then(res=>{
            const itemStr=this.util.pluralize('item',this.selectedRows.length)
            this.toastr.info(`${itemStr} copied`);
            this.getAssets()
            this.selectedRows=[]
        }).catch(error=>{
            console.log(error)
        })
    }

    /**
     * Moves the specified asset to a different location.
     * If multiple rows are selected, it calls the `move_multi` method.
     * Otherwise, it opens the move item dialog for the selected asset.
     * 
     * @param item - The asset to be moved.
     */
    move(item: Asset): void {

        if(!this._permissionsService.canMove(item)){
            this.ToastrService.error("You do not have permission to move this item.");
            return;
        }

        if (this.selectedRows.length > 1) {
            this.move_multi();
        } else {
            this._fileManagerComponent.moveItemDialog(item);
        }
    }

    /**
     * Moves multiple selected rows to a new location.
     */
    move_multi(): void {
        this.selectedRows.forEach(row => {
            if(!this._permissionsService.canMove(row)){
                this.ToastrService.error(`You do not have permission to move ${row.name}.`);
                return;
            }
        });
        this._fileManagerComponent.moveItemDialogMuti(this.selectedRows);
    }

    /**
     * Checks out an asset.
     * @param asset - The asset to be checked out.
     */
    checkoutAsset(asset:Asset){
        const ids:string[] = [asset.id];
        this.lockService.checkOutAsset(ids).then(res=>{
            this.toastr.warning("Item locked",'Success')
            this.getAssets();
        }).catch(error=>{
            console.log(error)
        })
    }

    /**
     * Checks in an asset.
     * @param {Asset} asset - The asset to be checked in.
     */
    checkInAsset(asset:Asset){
        const ids = [asset.id];
        this.isLoading = true;
        this.lockService.checkInAsset(ids).then(res=>{
            this.isLoading = false;
            this.toastr.success("Item unlocked",'Success');
            this.getAssets();
        }).catch(error=>{
            this.isLoading = false;
            console.log(error);
        })
    }

    /**
     * Requests access for a specific asset.
     * @param {Asset} asset - The asset for which access is being requested.
     */
    requestRelease(asset:Asset){
        const type=asset.type=='FILE'?'File':'Folder'
        const dialogRef = this._fuseConfirmationService.open({ message:`<b>"${asset.name}"</b> is locked. Press Confirm to Request Access.`, icon: { color: 'primary', name: 'feather:move' } });

        // Subscribe to afterClosed from the dialog reference
        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'confirmed') {
                 const assetIds = [asset.id];
                this.isLoading = true;
                const data = {ids : assetIds , url : window.location.href};
                this.lockService.requestRelease(data).then(res=>{
                    this.isLoading = false;
                    this.toastr.success("Request sent",'Success')
                    this.getAssets();
                }).catch(error=>{
                    this.isLoading = false;
                    console.log(error)
                })
               
            }
        });
    }

    /**
     * Checks if the asset is checked in.
     * @param asset - The asset to check.
     * @returns A boolean value indicating whether the asset is checked in.
     */
    isCheckedIn(asset: Asset): boolean {
        return this.util.isCheckedIn(asset) 
    }
    /**
     * Checks if the asset is checked out.
     * @param asset - The asset to check.
     * @returns A boolean value indicating whether the asset is checked out.
     */
    isCheckedOut(asset:Asset){
        return this.util.isCheckedOut(asset)
    }
    /**
     * Checks if an asset is requestable.
     * @param asset - The asset to check.
     * @returns A boolean indicating whether the asset is requestable or not.
     */
    isRequestable(asset: Asset): boolean {
        return this.util.isRequestable(asset)
    }
    /**
     * Checks if the asset is locked for the current user.
     * @param asset - The asset to check.
     * @returns A boolean indicating whether the asset is locked for the current user.
     */
    isLockedForCurrentUser(asset: Asset): boolean {
       return this.util.isLockedForCurrentUser(asset)
    }

    /**
     * Trims paths above the scoped root.
     * Caps displayed paths at 4 entries.
     */
    updateDisplayedPaths() {
        if (this.isWebComponent) {
            this.paths = this.util.scopePathToRoot(this.paths);
        }

        if (this.paths.length > 4) {
          const ellipsisPath = new AssetPathItem();
          ellipsisPath.name = '...';
          this.displayedPaths = [ellipsisPath, ...this.paths.slice(-3)];
        } else {
          this.displayedPaths = [...this.paths];
        }
    }
    
    /**
     * Toggles the display of full paths in the file manager list.
     * 
     * @param show - A boolean value indicating whether to show full paths or not.
     */
    toggleFullPaths(show: boolean, event?) {
        this.showFullPaths = show;
        if(this.showFullPaths)
        this.setOrigin(event);
    }

    /**
     * Hides the breadcrumb in the file manager list component.
     */
    hideBreadCrumb(){
        this.showFullPaths=false;
    }

    /**
     * Edits a file.
     * @param asset - The asset to be edited.
     */
    editFile(asset: Asset) {
        this.editFileInNewApp(asset, false) //edit existing file
    }

    /**
     * Opens the file in the DMS Desktop Agent using the drive:// custom protocol.
     * @param asset - The file asset to open.
     */
    viewInDesktop(asset: Asset): void {
        this.desktopAgentService.launch(asset);
    }

    /**
     * Creates a new file.
     */
    createNewFile() {
        this.editFileInNewApp(null, true) //create new file
    }

      /**
     * Opens the file in a new tab for preview after getting temporary token for authentication
     * @param asset - The asset object to be opened.
     */
      previewFile(asset:Asset){
      this.util.viewFile(asset).then( res => {{
        this.matMenuTrigger.restoreFocus = true
        this.matMenuTrigger.menuData = null
      }})
    }

    /**
     * Opens the file in a new tab for editing after getting temporary token for authentication
     * @param asset - The asset to edit.
     * @param isNew - Indicates whether the asset is new or not. Default is false.
     */
    editFileInNewApp(asset: Asset, isNew: boolean = false) {

        // first get temporary token for authentication

        const assetId = isNew ? this.routeFolderId : asset.id;
        const assetName = isNew ? "new_doc" : encodeURIComponent(asset.name);

        this.authService.getToken().then((res) => {
            const token = this.docService.getData(res).token
            this.isLoading = false
            const dms_editor_url = this.util.getDmsEditorUrl()
            const user_type = this.isWebComponent ?'L':'D'
            const url = dms_editor_url + "/#/auth/" + assetId + "/" + "?name=" + assetName + "&new=" + isNew + "&t=" + token+"&dut="+user_type ;;
            this.matMenuTrigger.restoreFocus = true
            this.matMenuTrigger.menuData = null
            this.util.openExternalViewEditLink(url);
        })
            .catch((err) => {
                console.log(err);
            });
    }

    animationStarted(event){
    }

    setOrigin(event: MouseEvent): void {
        this.trigger = event.target as HTMLElement;
      }

      /**
     * Sets the `assetId` and `activeTab` properties based on the provided `id` and `tab` values.
     * @param id - The ID of the asset.
     * @param tab - The active tab index (default is '0').
     */
     drawerView(id, tab = null){
        const currentPath = this._router.url;
        if(this.defaultView){
            this.assetId = id;
            this.activeTab = tab ? tab : '0';
        } 

        else {
            if (currentPath.includes('/file-manager/folders/')) {

                tab ? this._router.navigate(currentPath.includes('/details/') ? [`apps/file-manager/folders/${this.routeFolderId}/details/`, id] : [currentPath + '/details/', id], { queryParams: { activeTab: tab } })
                    : this._router.navigate(currentPath.includes('/details/') ? [`apps/file-manager/folders/${this.routeFolderId}/details/`, id] : [currentPath + '/details', id]);
            }
            else {

                tab ? this._router.navigate(currentPath.includes('/details/') ? ['apps/file-manager/details/', id] : [currentPath + '/details/', id], { queryParams: { activeTab: tab } }) :
                    this._router.navigate(currentPath.includes('/details/') ? ['apps/file-manager/details/', id] : [currentPath + '/details', id]);
            }

        }

    }



    toggleCheckAll():void {

        this.isAllRowsSelected = !this.isAllRowsSelected;

        if (this.isAllRowsSelected) {
            this.selectedRows = this.assets;
        }
        if (!this.isAllRowsSelected) {
            this.selectedRows = [];
        }

        this.toggleMultiRowSelectedOptions()
    }

    toggleRowCheck(checked: boolean, asset: Asset = null):void {

        if (checked) {
            this.selectedRows.push(asset)
        } else {
            this.selectedRows = this.selectedRows.filter(row => row.id !== asset.id);
        }

        this.isAllRowsSelected = this.selectedRows.length === this.assets.length;

        this.toggleMultiRowSelectedOptions()

    }

    resetSelectedRows():void {
        this.selectedRows = [];
        this.isAllRowsSelected = false;
        this.multiItemSelectPanel?.close();
    }

    isSelectedRow(asset: Asset):boolean {
        return this.selectedRows.some(item => item.id === asset.id)
    }

    isFolderRowSelected():boolean {
        const index = this.selectedRows.findIndex(row => row.type == 'FOLDER')
        return index !== -1

    }

    toggleMultiRowSelectedOptions():void {
        if (this.selectedRows.length > 0) {
            this.multiItemSelectPanel.open();
            this.eventSer.multiRowSelect.emit();
        } else {
            this.multiItemSelectPanel.close();
        }
    }

    onSearchApplied(search: AssetsSearch):void {
        this.showSearchResults = true;
        this.inputSearch = search;
    }

    onSearchedAssetClick(folderId:string){
        this.showSearchResults = false;
        this.folderView(folderId)
    }

    async setCopilotId(asset:Asset | CopilotAssetDetails = new Asset(), agentAssistant:Assistant | Agent = null, trigger: MatMenu = null){
        this.selectedAgent = new Agent();
        this.selectedAssistant = new Assistant();
        
        if(agentAssistant){
            if('assistantType' in agentAssistant){
                this.selectedAssistant = agentAssistant as Assistant;
                this.selectedAgent = new Agent();
            }
            else if('agentType' in agentAssistant){
                this.selectedAgent = agentAssistant as Agent;
                this.selectedAssistant = new Assistant();
            }
        }
        const assetId = asset?.id ?? null;
   
        const isParsing = asset?.parsingProgress == 'InProgress' || asset?.parsingProgress==='Pending' || asset?.parsingProgress===null;
        if(isParsing){
            this._fileManagerService.open_copilot_parse_info(asset.type);
            return
        }

        this.copilotAssetId = assetId ? assetId : this.routeFolderId;
        if(trigger)
            trigger.closed.emit(); // ensures it doesn’t hang open
        this.eventSer.toggleCopilot.emit(true);
         
    }

    onCopilotClose(){
        this.copilotAssetId = null;
        this.eventSer.toggleCopilot.emit(false);
    }

    loadSettings(){
        this.ragService.getSettings().then((response) => {
          this.settings = this.ragService.getData(response);
          if (this.settings) {
            this.isLeastOneAgentEnabled = this.settings.agents.some(agent => agent.enabled);
            const isAssistantEnabled = this.settings.assistants.some(assitant => assitant.enabled);
            this.isLeastOneFolderAgentEnabled = this.settings.agents.some(agent => agent.enabled && agent.folderEnabled);
            this.isLeastOneAssistantOrAgentEnabled = isAssistantEnabled || this.isLeastOneAgentEnabled;
            this.isCopilotEnabled = this.settings.ragEnabled;
          }
        }
        ).catch(err => {
          console.error('Error fetching RAG settings', err);
        }
        );
      }

    getAssetCopilotDetails(assetId: string): Promise<any> {
        return new Promise((resolve, reject) => {
                this.ragService.getAssetDetails(assetId).then(res => {
                    const data: CopilotAssetDetails = this.docService.getData(res);
                    resolve(data);
                   
                }).catch(error => {
                    console.log(error)
                    resolve(null)
                })
        })
    } 

    async onActionClick(){
    if(this.currentFolderDetails.parsingProgress !=='Completed' && this.currentFolderDetails.parsingProgress!==null){
        this.getAndSetCurrentFolderCopilotDetails();
    }
    }

    async getAndSetCurrentFolderCopilotDetails(){
        if(!this.isCopilotEnabled) return;
        const data:CopilotAssetDetails = await this.getAssetCopilotDetails(this.routeFolderId);
            const isSingleFileParsed = data.ragScopedAssets > 0 ;
            this.currentFolderDetails = data;
            this.currentFolderDetails.parsingProgress = isSingleFileParsed ? 'Completed' : data.parsingProgress;
    }

    onFileMenuClick(file:Asset){
        this.checkCopilotParsingStatus(file)
    }

    onFolderMenuClick(file:Asset){
        this.checkCopilotParsingStatus(file)
    }

    async checkCopilotParsingStatus(selectedItem:Asset){
        if(selectedItem.parsingProgress !=='Completed' && this.currentFolderDetails.parsingProgress!==null){
            const data:CopilotAssetDetails = await this.getAssetCopilotDetails(selectedItem.id);
            if(data.type==='FOLDER'){
                const isSingleFileParsed = data.ragScopedAssets > 0 ;
                selectedItem.parsingProgress = isSingleFileParsed ? 'Completed' : data.parsingProgress;
                return 
            }
            selectedItem.parsingPercentage = data.parsingPercentage ?? 0;
            selectedItem.parsingProgress = data.parsingProgress;
        }
    }

    appendUploadedFile(newAsset: Asset): void {
        if (!newAsset) return;

        const uploadedToFolder = newAsset.parent?.id ?? null;
        const activeFolder = this.routeFolderId ?? null;
        if (uploadedToFolder !== activeFolder) return;

        if (newAsset.type === 'FILE') {
            this.files.push(newAsset);
            this.totalAssets.files++;
        } else if (newAsset.type === 'FOLDER') {
            this.folders.push(newAsset);
            this.totalAssets.folders++;
        }
        this.assets = [...(this.folders || []), ...(this.files || [])];
        this.total++;
    }

    replaceUploadedFile(newAsset: Asset): void {
        if (!newAsset) return;

        const uploadedToFolder = newAsset.parent?.id ?? null;
        const activeFolder = this.routeFolderId ?? null;
        if (uploadedToFolder !== activeFolder) return;

        const idx = this.files.findIndex(f => f.name === newAsset.name);
        if (idx === -1) {
            this.files.push(newAsset);
            this.totalAssets.files++;
            this.total++;
        } else {
            this.files[idx] = newAsset;
        }
        this.assets = [...(this.folders || []), ...this.files];
    }

    // Leftover clicks from a double-click
    private get _justNavigated(): boolean {
        return Date.now() - this._navigatedAt < this._navClickGuardMs;
    }

    openFolderClick(event: MouseEvent, folderId: string): void {
        this.stopPropagation(event);
        if (this._justNavigated) return;
        this.folderView(folderId);
    }

    drawerViewClick(event: MouseEvent, id: string): void {
        this.stopPropagation(event);
        if (this._justNavigated) return;
        this._clicks.click(() => this.drawerView(id));
    }

    drawerViewDblClick(asset: Asset): void {
        if (this._justNavigated) return;
        this._clicks.dblClick(() => {
            if (asset.type === 'FOLDER') {
                this.folderView(asset.id);
            } else if (this._actionRegistry.isAllowed('view', asset)) {
                this.previewFile(asset);
            } else if (this._actionRegistry.isAllowed('openOnDesktop', asset)) {
                this.viewInDesktop(asset);
            } else {
                this.drawerView(asset.id);
            }
        });
    }


}
